module.exports = __webpack_public_path__ + "/login_ui/img/ma-2a9ae9c7810d7c967a180f5935a74e58.svg";